var $5d029553257fceab$exports = {};
$5d029553257fceab$exports = {
    "alert": `Alerta`,
    "dismiss": `Descartar`
};


export {$5d029553257fceab$exports as default};
//# sourceMappingURL=pt-BR.module.js.map
